module.exports = __webpack_public_path__ + "static/media/18ECA21.514a31c3.jpg";